import React, { useContext, useEffect, useState } from "react";
import { deleteFAQ } from "../redux/actions/FAQ";
import UserContext from "../context/UserContext";
import { Tooltip, OverlayTrigger } from "react-bootstrap";
import { ArrowDownIcon, DeleteIcon, EditIcon, HistoryIcon, HomeIcon, PLusIcon, SearchIcon } from "../assets/Icons";
import FAQSubLayer1 from "./Layer/FAQSubLayer1";
import { SERVER_IP, ud, jwt } from "../Server";
import { useDispatch } from "react-redux";
import FAQCreate from "./FAQCreate";
import SearchFAQ from "./SearchFAQ";
import FAQEdit from "./FAQEdit";
import FAQAdd from "./FAQAdd";
import Modal from "./Modal";
import axios from "axios";
import NoDataFound from "../common/NoDataFound";
import Swal from "sweetalert2";
import Search from "../common/Search";

export default function FAQMain() {
  const dispatch = useDispatch();
  const context = useContext(UserContext);
  const { updateddata, setUpdateddata } = context;

  const [FAQData, setFAQData] = useState({});
  const [searchinput, setSearchinput] = useState("");
  const [searchresult, setSearchresult] = useState({});
  const [searchFAQdata, setSearchFAQdata] = useState({});

  const fetchFAQ = async () => {
    var data = {};
    let headers = {
      user_id: ud.id.toString(),
      session_id: ud.session_id.toString(),
      user_type: ud.usertype.toString(),
      main_id: ud.main_id.toString(),
      jwt_token: jwt,
      c_id: ud.c_id.toString(),
    };
    const result = await axios.post(`${SERVER_IP}/userfaq`, data, { withCredentials: true, headers: headers });
    if (result.data.error === false) {
      setFAQData(result.data);
    } else {
      setFAQData(result.data);
    }
  };

  const searchHandler = async (e) => {
    e.preventDefault();
    setSearchinput(e.target.value);
    e.target.value === "" && setSearchFAQdata({});
    // Api Call
    var data = {
      searchtxt: searchinput,
    };
    let headers = {
      user_id: ud.id.toString(),
      session_id: ud.session_id.toString(),
      user_type: ud.usertype.toString(),
      main_id: ud.main_id.toString(),
      jwt_token: jwt,
      c_id: ud.c_id.toString(),
    };
    const result = await axios.post(`${SERVER_IP}/userfaq/search`, data, { withCredentials: true, headers: headers });
    if (result.data.error === false) {
      setSearchresult(result.data);
    } else {
      setSearchresult(result.data);
    }
  };

  const getSearchFAQ = async (faq_id) => {
    setSearchresult({});
    setFAQData({});
    // Api Call
    var data = { faq_id };
    let headers = {
      user_id: ud.id.toString(),
      session_id: ud.session_id.toString(),
      user_type: ud.usertype.toString(),
      main_id: ud.main_id.toString(),
      jwt_token: jwt,
      c_id: ud.c_id.toString(),
    };
    const result = await axios.post(`${SERVER_IP}/userfaq/search/result`, data, {
      withCredentials: true,
      headers: headers,
    });
    if (result.data.error === false) {
      // setFAQData({ close: true })
      setSearchFAQdata(result.data);
      setFAQData(result.data);
      updateddata ? setUpdateddata(false) : setUpdateddata(true);
    } else {
      setSearchFAQdata(result.data);
    }
  };

  const handleDelete = async (faq_id) => {
    Swal.fire({
      title: "Are you sure?",
      text: "Do you really want to delete this item?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#d33",
      cancelButtonColor: "#3085d6",
      confirmButtonText: "Delete",
      cancelButtonText: "Cancel",
    }).then(async (result) => {
      if (result.isConfirmed) {
        var data = { faq_id };
        let headers = {
          user_id: ud.id.toString(),
          session_id: ud.session_id.toString(),
          user_type: ud.usertype.toString(),
          main_id: ud.main_id.toString(),
          jwt_token: jwt,
          c_id: ud.c_id.toString(),
        };
        const result = await axios.post(`${SERVER_IP}/userfaq/delete`, data, {
          withCredentials: true,
          headers: headers,
        });
        fetchFAQ();
        if (result.data.error === false) {
          Swal.fire({
            title: "Success",
            text: result.msg,
            icon: "success",
            confirmButtonText: "Ok",
          });
        } else {
          Swal.fire({
            title: "Error",
            text: result.msg,
            icon: "error",
            confirmButtonText: "Ok",
          });
        }
      }
    });
  };

  useEffect(() => {
    Object.keys(searchFAQdata).length === 0 && fetchFAQ();
  }, [updateddata, searchinput]);

  return (
    <>
      <div className="container-fluid faqpage">
        <div className="xp-breadcrumbbar xp-heading pr-0">
          <div className="row w-100 py-3">
            <div className="col-md-8 mb-4">
              <h3>Frequently asked questions</h3>
            </div>
            <div className="col-md-8 col-lg-8">
              <div className="xp-breadcrumb gradient-border mt-0">
                <ol className="breadcrumb">
                  <li className="breadcrumb-item">
                    <a onClick={() => (window.location.href = "/dashboard")}>
                      <HomeIcon />{" "}
                    </a>
                  </li>
                  <li className="breadcrumb-item active" aria-current="page">
                    Faq
                  </li>
                </ol>
              </div>
            </div>
            <div className="col-md-4">
              <div className="faqsearchbtn h-100">
                <div className="inputgroup h-100">
                  {/* <div className="searchWrapper w-100"> */}
                  <Search onChange={searchHandler} value={searchinput} placeholder="Search..." />
                  {/* </div> */}
                  {searchinput !== "" && (
                    <>
                      {Object.keys(searchresult).length === 0 ? (
                        // Initial case
                        <></>
                      ) : searchresult.searchResult ? (
                        // Result found
                        <div className="card position-absolute" style={{ width: "96%", zIndex: "100" }}>
                          {searchresult.searchResult.map((element) => {
                            return (
                              <button
                                type="button"
                                className="list-group-item list-group-item-action ml-0"
                                key={element.id}
                                onClick={() => getSearchFAQ(element.id)}
                              >
                                {element.title}
                              </button>
                            );
                          })}
                        </div>
                      ) : (
                        // No result found
                        <div className="card position-absolute" style={{ width: "96%", zIndex: "100" }}>
                          <button type="button" className="list-group-item list-group-item-action">
                            {searchresult.message}
                          </button>
                        </div>
                      )}
                    </>
                  )}
                </div>
                <button
                  type="button"
                  className="btn btn-white btn-lg rounded"
                  data-toggle="modal"
                  data-target="#createModal"
                >
                  + Create FAQs
                </button>
              </div>
            </div>
          </div>
        </div>
        <div className="row mx-1 d-flex justify-content-between">
          <div className="col">
            <div
              className="modal fade bd-example-modal-lg"
              id="createModal"
              tabIndex="-1"
              role="dialog"
              aria-labelledby="createModalLabel"
              aria-hidden="true"
            >
              <FAQCreate />
            </div>
          </div>
          <div className="col"></div>
        </div>
        <div className="faqlisthere">
          {Object.keys(FAQData).length === 0 ? (
            // Loader
            <div className="d-flex justify-content-center">
              <div className="spinner-border" role="status">
                <span className="sr-only">Loading...</span>
              </div>
            </div>
          ) : // FAQData.faqresult && FAQData.faqresult.length > 0 ? (
          //   FAQData.faqresult.map((element) => {
          FAQData.faqresult && FAQData.faqresult.length > 0 ? (
            [...FAQData.faqresult]
              .sort((a, b) => new Date(b.created_on) - new Date(a.created_on))
              .map((element) => {
                return (
                  <div className="row px-3">
                    <div className="col-md-12">
                      <div className="accordion faqnewdesign m-2" id={`accordionExample${element.id}`} key={element.id}>
                        <div className="card">
                          <div
                            className="card-header d-flex justify-content-between"
                            id={`heading${element.id}`}
                            style={{ padding: "0.75rem 0rem 0.75rem 1.25rem" }}
                          >
                            <div className="d-flex align-items-center mb-0">
                              <button
                                className="btn btn-link btn-block text-left p-0"
                                type="button"
                                data-toggle="collapse"
                                data-target={`#collapse${element.id}`}
                                aria-expanded="true"
                                aria-controls={`collapse${element.id}`}
                              >
                                <span>
                                  <ArrowDownIcon />
                                </span>
                                {element.title}
                              </button>
                            </div>

                            <div className="d-flex">
                              <div className="d-flex">
                                <div className="mr-5">
                                  <small className="col-2.5 d-flex align-items-center">
                                    <strong>Created by: {element.created_by} </strong>{" "}
                                  </small>
                                  <small className="col-2.5 d-flex align-items-center">
                                    On: {new Date(element.created_on).toLocaleString()}
                                  </small>
                                </div>
                                <div className="mr-5">
                                  <small className="col-2.5 d-flex align-items-center">
                                    {element.modify_by ? (
                                      <strong>Edited by: {element.modify_by}</strong>
                                    ) : (
                                      <strong>Not modified yet</strong>
                                    )}
                                  </small>
                                  <small className="col-2.5 d-flex align-items-center">
                                    {element.modify_on
                                      ? `On: ${new Date(element.modify_on).toLocaleString()}`
                                      : "Not modified yet"}
                                  </small>
                                </div>
                              </div>
                              <div className="faqactionbtn">
                                <button
                                  type="button"
                                  className="btn btn-info mx-1"
                                  data-toggle="modal"
                                  data-target={`#logModal${element.id}`}
                                >
                                  <i>
                                    <HistoryIcon />
                                  </i>
                                </button>
                                {/* <OverlayTrigger placement="top" overlay={<Tooltip id="tooltip-view">Faq Add</Tooltip>}>
                            <button
                              type="button"
                              className="btn btn-success mx-1"
                              data-toggle="modal"
                              data-target={`#addModal${element.id}`}
                            >
                              <i>
                                <PLusIcon />
                              </i>
                            </button>
                          </OverlayTrigger> */}
                                <button
                                  type="button"
                                  className="btn btn-warning mx-1"
                                  data-toggle="modal"
                                  data-target={`#editModal${element.id}`}
                                >
                                  <i>
                                    <EditIcon />{" "}
                                  </i>
                                </button>
                                <button
                                  type="button"
                                  className="btn btn-danger mx-1"
                                  onClick={() => {
                                    // dispatch(deleteFAQ(element.id, fetchFAQ));
                                    handleDelete(element.id);
                                    updateddata ? setUpdateddata(false) : setUpdateddata(true);
                                  }}
                                >
                                  <i>
                                    <DeleteIcon />
                                  </i>
                                </button>
                              </div>
                            </div>
                          </div>

                          <div
                            className="modal fade bd-example-modal-lg"
                            id={`logModal${element.id}`}
                            tabIndex="-1"
                            role="dialog"
                            aria-labelledby="logModalLabel"
                            aria-hidden="true"
                          >
                            <Modal faq_id={element.id} />
                          </div>

                          <div
                            className="modal fade bd-example-modal-lg"
                            id={`addModal${element.id}`}
                            tabIndex="-1"
                            role="dialog"
                            aria-labelledby="addModalLabel"
                            aria-hidden="true"
                          >
                            <FAQAdd parent_id={element.id} />
                          </div>

                          <div
                            className="modal fade bd-example-modal-lg"
                            id={`editModal${element.id}`}
                            tabIndex="-1"
                            role="dialog"
                            aria-labelledby="editModalLabel"
                            aria-hidden="true"
                          >
                            <FAQEdit
                              faq_id={element.id}
                              faq_title={element.title}
                              faq_description={element.description}
                            />
                          </div>

                          <div
                            id={`collapse${element.id}`}
                            className="collapse show"
                            aria-labelledby={`heading${element.id}`}
                            data-parent={`#accordionExample${element.id}`}
                          >
                            <div className="card-body">{element.description}</div>
                          </div>

                          {/* <div
                      id={`collapse${element.id}`}
                      className="collapse"
                      aria-labelledby={`heading${element.id}`}
                      data-parent={`#accordionExample${element.id}`}
                    >
                      <div className="card-body" style={{ padding: "0 0 0 9px" }}>
                        <FAQSubLayer1 parent_id={element.id} />
                      </div>
                    </div> */}
                        </div>
                      </div>
                    </div>
                  </div>
                );
              })
          ) : (
            <>
              <div className="card mx-4">
                <div className="card-body">
                  <NoDataFound headText={`No Faq Found`} />
                </div>
              </div>
            </>
          )}
        </div>
      </div>
    </>
  );
}
